import { Controller } from "@hotwired/stimulus"

// Shows and hides the change-request composer's image and link panels.
export default class extends Controller {
  static targets = ["panel"]

  toggle({ currentTarget, params: { panel } }) {
    const hidden = this.panelTargets.find((el) => el.dataset.panel === panel)?.classList.toggle("hidden")
    currentTarget.setAttribute("aria-expanded", String(hidden === false))
  }
}
